import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MessageCircle, MapPin, Mail, Phone } from "lucide-react";
import logo from "../imagem/logo.png";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-luxury py-5">
      <Container>
        <Row className="gy-5 justify-content-between">
          {/* Coluna de Branding e Identidade */}
          <Col lg={4} md={12} className="branding-col pe-lg-5">
            <img src={logo} alt="Henrimack" className="logo-footer mb-4" />
            <p className="footer-slogan mb-4">
              Henrimack Sistemas: Criando softwares de elite para revolucionar a forma como as empresas gerenciam seus ativos e clientes.
            </p>
            <div className="social-pills-wrap">
              <a
                href="https://wa.me/5547992229810"
                target="_blank"
                rel="noopener noreferrer"
                className="pill"
                aria-label="Falar no WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
            </div>
          </Col>

          {/* Colunas de Navegação e Soluções */}
          <Col lg={2} md={4} className="col-6 navigation-col">
            <h6 className="footer-subtitle-luxury mb-4">Acesso Rápido</h6>
            <ul className="footer-links list-unstyled">
              <li><Link to="/">Home</Link></li>
              <li><a href="/#about">Quem Somos</a></li>
              <li><a href="/#services">Soluções</a></li>
              <li><a href="/#portfolio">Projetos</a></li>
              <li><a href="/#contact">Conversar</a></li>
            </ul>
          </Col>

          <Col lg={3} md={4} className="col-6 solutions-col">
            <h6 className="footer-subtitle-luxury mb-4">Nossas Soluções</h6>
            <ul className="footer-links list-unstyled">
              <li><Link to="/sge-pro">SGE Pro (Eventos)</Link></li>
              <li><Link to="/beauty-agenda">Beauty Agenda</Link></li>
              <li><Link to="/hemathclin">HemathClin</Link></li>
              <li><Link to="/vitalis">Vitalis</Link></li>
              <li><Link to="/alicerce">Alicerce</Link></li>
              <li><Link to="/sistemas-personalizados">Software Sob Medida</Link></li>
            </ul>
          </Col>

          {/* Coluna de Contato */}
          <Col lg={3} md={4} className="contact-col">
            <h6 className="footer-subtitle-luxury mb-4">Canais Diretos</h6>
            <div className="contact-details">
              <div className="contact-item d-flex align-items-center mb-3">
                 <div className="icon-wrap-elite"><MapPin size={16} /></div>
                 <span className="small text-gray-sub">Santa Catarina - Atendimento Global</span>
              </div>
              <div className="contact-item d-flex align-items-center mb-3">
                 <div className="icon-wrap-elite"><Phone size={16} /></div>
                 <a href="tel:+5547992229810" className="small text-gray-sub">+55 47 99222-9810</a>
              </div>
              <div className="contact-item d-flex align-items-center">
                 <div className="icon-wrap-elite"><Mail size={16} /></div>
                 <a href="mailto:contato@henrimacksistemas.com.br" className="small text-gray-sub">contato@henrimacksistemas.com.br</a>
              </div>
            </div>
          </Col>
        </Row>

        <div className="footer-copy mt-5 pt-4 border-top border-dark">
           <Row className="align-items-center text-center text-md-start gy-3">
              <Col md={6}>
                 <p className="small text-muted-sub mb-0">
                    © {currentYear} <span className="text-gold-elite">Henrimack Sistemas</span>. Todos os direitos reservados.
                 </p>
              </Col>
              <Col md={6} className="text-md-end">
                 <span className="footer-badge-elite">Softwares de Elite</span>
              </Col>
           </Row>
        </div>
      </Container>

      <style>{`
        .footer-luxury {
          background-color: #000;
          border-top: 1px solid rgba(255,255,255,0.05);
          color: #b0b0b0;
          padding-top: 3rem !important;
          padding-bottom: 3rem !important;
        }

        .logo-footer {
          max-height: 60px;
          filter: drop-shadow(0 0 10px rgba(228, 168, 122, 0.2));
        }

        .footer-slogan {
          font-size: 0.9rem;
          line-height: 1.8;
          color: #888;
          max-width: 350px;
        }

        .footer-subtitle-luxury {
          font-weight: 800;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 3px;
          color: #fff;
          margin-bottom: 2rem !important;
        }

        .footer-links a {
          text-decoration: none;
          color: #888;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          display: inline-block;
          margin-bottom: 0.8rem;
        }

        .footer-links a:hover {
          color: var(--elite-gold);
          transform: translateX(5px);
        }

        .social-pills-wrap { display: flex; gap: 15px; }
        .pill {
          width: 40px; height: 40px;
          display: flex; align-items: center; justify-content: center;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.05);
          color: var(--elite-gold);
          border-radius: 12px;
          transition: all 0.4s ease;
        }
        .pill:hover {
          background: var(--elite-gold);
          color: #000;
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(228, 168, 122, 0.2);
        }

        .icon-wrap-elite {
          width: 32px; height: 32px;
          background: rgba(228,168,122,0.1);
          color: var(--elite-gold);
          display: flex; align-items: center; justify-content: center;
          border-radius: 8px;
          margin-right: 15px;
        }

        .text-gray-sub { color: #888; text-decoration: none; transition: 0.3s; }
        .text-gray-sub:hover { color: #fff; }

        .text-muted-sub { color: #555; }
        .text-gold-elite { color: var(--elite-gold); font-weight: 800; }

        .footer-badge-elite {
           background: rgba(255,255,255,0.02);
           padding: 8px 18px;
           border-radius: 50px;
           border: 1px solid rgba(255,255,255,0.05);
           font-size: 0.65rem;
           text-transform: uppercase;
           letter-spacing: 2px;
           color: #666;
           font-weight: 800;
        }

        @media (max-width: 992px) {
           .branding-col { text-align: center; margin-bottom: 4rem; }
           .footer-slogan { margin-left: auto; margin-right: auto; }
           .social-pills-wrap { justify-content: center; }
           .navigation-col, .solutions-col, .contact-col { text-align: center; margin-bottom: 3rem; }
           .contact-item { justify-content: center; }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
